import { Link } from 'react-router-dom';
import { viewPrivacyPolicy } from '../../services/amplitude';

const TNCLink = () => {
  return (
    <p className="terms-condition">
      Anda telah mengetahui dan menyetujui
      <Link to="/syarat-ketentuan" onClick={() => viewPrivacyPolicy()}>
        {' '}
        Syarat & Ketentuan
      </Link>{' '}
      dari IBID MAP
    </p>
  );
};

export default TNCLink;
